import { Trans } from '@lingui/macro';

import AlertError from '../../generic/error/AlertError';

const CheckoutDetailErrors = ({ duplicateParticipants }) => {
  return <>{duplicateParticipants && <AlertError message={<Trans>Participants names must be different.</Trans>} />}</>;
};

export default CheckoutDetailErrors;
